import React from "react";
import { Divider, Grid2, IconButton, Typography } from "@mui/material";

export const InfoSection = ({ label, value }) => {
  return (
    <>
      <Grid2 container spacing={4} sx={{ pt: 2, pl: 4, pr: 4, pb: 2 }}>
        <Grid2 size={6}>
          <Typography variant="body2" color="textSecondary">
            {label}
          </Typography>
        </Grid2>
        <Grid2 size={6}>
          <Typography variant="body2">{value}</Typography>
        </Grid2>
      </Grid2>
      <Divider />
    </>
  );
};
